import Button from "components/button/button.component";
import React from "react";
import assetPath from "utils/assetPath.utils";
import parse from "html-react-parser";
//
import "./textBlock.block.scss";
import classNames from "classnames";

interface Props {
  id: string;
  overHeadline?: string;
  headline: string;
  text: string[];
  button: {
    link: string;
    label: string;
  };
  divider?: boolean;
}

const TextBlock: React.FC<Props> = (props) => {
  return (
    <div className={classNames("text-block", {"is-divider": props.divider})} id={props.id}>
      <div className="text-block__wrapper">
        <div className="text-block__head">
          {!!props.overHeadline && <img src={assetPath(props.overHeadline)}  className="text-block__head-sub" />}
          <h2>{props.headline}</h2>
        </div>
        <div className="text-block-text__container">
          {props.text.map((item, key) => (
            <p key={key}>{parse(item)}</p>
          ))}
        </div>
        {!!props.button && (
          <Button {...props.button} className="text-block-button" bigger />
        )}
      </div>
    </div>
  );
};

export default TextBlock;
